import { Routes } from '@angular/router';
import { SecureComponent } from './secure.component';
import { MsalGuard } from '@azure/msal-angular';

export const secureRoutes: Routes = [
  {
    path: 'secure',
    component: SecureComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: 'tasks',
        loadComponent: () =>
          import('./tasks/tasks.component').then(
            (m) => m.TasksComponent,
          ),
        children: [
          {
            path: 'create-successor-technology',
            loadComponent: () =>
              import('./tasks/create-successor-technology/create-successor-technology.component').then(
                (m) => m.CreateSuccessorTechnologyComponent,
              ),
          },
          {
            path: 'create-interface',
            loadComponent: () =>
              import('./tasks/create-interface/create-interface.component').then(
                (m) => m.CreateInterfaceComponent,
              ),
          },
          {
            path: '',
            redirectTo: 'create-successor-technology',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: "chat",
        loadComponent: () =>
          import('./chat/chat.component').then(
            (m) => m.ChatComponent,
          ),
      },
      { path: '', redirectTo: 'tasks', pathMatch: 'full' },
      { path: '**', redirectTo: 'tasks' },
    ],
  },
];
